const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
  async deleteRoom({getters, dispatch}, room){
    let res = await dispatch('api/nav/adminDeleteRoom', room.id)

    if(res.success) {
      if(getters.getSpaceIfPortal) dispatch('popups/nav/successDeletingSpacePortal', room.name)
      else dispatch('popups/nav/successDeletingRoom', room.name)
      dispatch('analytics/deleteRoom', room)
      dispatch('stopViewingRoom') //stop viewing room so you don't get more errors
    }
    else {
      if(getters.getSpaceIfPortal) dispatch('popups/nav/errorDeletingSpacePortal')
      else dispatch('popups/nav/errorDeletingRoom')
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
